<template>
  <div>
    <h5 class>Carteira</h5>
    <multiselect
      v-model="region"
      :options="filter.regions"
      :loading="filter.isLoadingRegions"
      @input="notifyChange"
      placeholder="Selecionar Carteira"
      label="name"
      track-by="id"
      :select-label="''"
      :selected-label="'Selecionado'"
      :deselect-label="''"
       @search-change="loadFilteredRegions"
    ></multiselect>
  </div>
</template>

<script>
import Multiselect from "@/components/Multiselect/translated_multiselect.vue";



export default {
  name: "crop-filter-wallet",
  components: {
    Multiselect,
  },
  props: ["region"],
  data() {
    return {
      filter: {
        region: {},
        regions: [],
        isLoadingRegions: true,
      },
      client: [],
      filteredRegions: [],
      paginated_data: {
        current: 1,
        count: 10,
        per_page: 10,
      },
    };
  },
  created() {
    
  },
  methods: {
    loadFilteredRegions(q) {
      // var data = {
      //   per_page: this.paginated_data.per_page,
      // };
          
      this.filter.isLoadingRegions = true;
      this.$http.secured
        .get("/api/v1/regions",{params: {name_only: true, q: {name: q}}})
        .then((response) => {
          this.filter.regions = response.data
          this.filter.isLoadingRegions = false;
        })
        .catch(() => this.filter.isLoadingRegions = false);
    },
      findClients(query){
      var data = {
        per_page: 10,
        q: {},
      }

      if(query.trim()) data.q.name = query
      if(this.filter.regions && this.filter.regions) data.q.region_ids = this.filter.regions

      this.filter.isLoadingClients = true
      this.$http.secured
          .get("/api/v1/regions",{params: {name_only: true}})
          .then((response) => {
            this.filter.regions = response.data
            this.filter.isLoadingRegions = false
          })
          .catch(() => this.filter.isLoadingRegions = false);
    },
    notifyChange(region) {
      this.$emit("selected", region);
    },
  },
  mounted() {
    this.loadFilteredRegions();
  },
};
</script>
